import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import attendeePickupAssignmentAPI from '@infrastructure/attendee-pickup-assignment-api';
export const createAttendeePickupAssignmentAsync = createAsyncThunk('attendeePickupAssignment/create', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.createAttendeePickupAssignment(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateAttendeePickupAssignmentAsync = createAsyncThunk('attendeePickupAssignment/update', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.updateAttendeePickupAssignment(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllAttendeePickupAssignmentsAsync = createAsyncThunk('attendeePickupAssignment/getAll', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.getAllAttendeePickupAssignments(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAssignedAttendeesByPickupLocationIdAsync = createAsyncThunk('attendeePickupAssignment/getAssignedAttendeesByPickupLocationId', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.getAssignedAttendeesByPickupLocationId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUnassignedAttendeesByPickupLocationIdAsync = createAsyncThunk('attendeePickupAssignment/getUnassignedAttendeesByPickupLocationId', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.getUnassignedAttendeesByPickupLocationId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAttendeePickupAssignmentByIdAsync = createAsyncThunk('attendeePickupAssignment/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.getAttendeePickupAssignmentById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteAttendeePickupAssignmentAsync = createAsyncThunk('attendeePickupAssignment/delete', async (id, { rejectWithValue }) => {
    try {
        await attendeePickupAssignmentAPI.deleteAttendeePickupAssignment(id);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const unassignAttendeeFromVehicleAsync = createAsyncThunk('attendeePickupAssignment/unassignFromVehicle', async (attendeeIds, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.unassignAttendeeFromVehicle(attendeeIds);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const assignAttendeeToVehicleAsync = createAsyncThunk('attendeePickupAssignment/assignToVehicle', async ({ attendeeIds, vehicleId }, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.assignAttendeeToVehicle(attendeeIds, vehicleId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAttendeesByVehicleIdAsync = createAsyncThunk('attendeePickupAssignment/getAttendeesByVehicleId', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.getAttendeesByVehicleId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const assignCoordinatorAsync = createAsyncThunk('attendeePickupAssignment/assignCoordinator', async ({ request }, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.assignCoordinator(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUnassignedAttendeesByEventIdAsync = createAsyncThunk('attendeePickupAssignment/getUnassignedAttendeesByEventId', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.getUnassignedAttendeesByEventId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAssignedAttendeesByEventIdAsync = createAsyncThunk('attendeePickupAssignment/getAssignedAttendeesByEventId', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.getAssignedAttendeesByEventId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const reassignAttendeesToPickupLocationAsync = createAsyncThunk('attendeePickupAssignment/reassignAttendeesToPickupLocation', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.reassignAttendeesToPickupLocation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateVehicleAttendeeCountAsync = createAsyncThunk('attendeePickupAssignment/updateVehicleAttendeeCount', async (request, { rejectWithValue }) => {
    try {
        const response = await attendeePickupAssignmentAPI.assignAttendeeCountToVehicle(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
